import { useMutation } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { toast } from "react-toastify";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";

type Props = {
  onSuccess?: (data: string) => void;
};

export const useUpdateUserProfileAvatar = (props?: Props) => {
  const { onSuccess } = props || {};
  const fileApi = getUsersApiClient();
  const mutation = useMutation({
    mutationFn: async ({ file }: { file: File }) => {
      const response = await fileApi.userControllerUpdateUserAvatar({
        file,
      });
      onSuccess?.(response);
      toast.success("Profile photo updated", {
        toastId: "user-avatar-updated",
      });
      return response;
    },
    onError: async (error) => {
      console.error("Failed to upload user avatar", error);
      const apiError = await apiResponseErrorHandler(error);
      if (apiError.status >= 400 && apiError.status < 500) {
        toast.error(apiError.errors[0], {
          toastId: "upload-user-avatar-error",
        });
        return;
      }
      toast.error("Error uploading user avatar", {
        toastId: "upload-user-avatar-error",
      });
    },
  });

  return mutation;
};
